
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { JdData } from 'src/app/common-interfaces-classes/JdData';

@Injectable({
    providedIn: 'root'
})
export class EventService {

    private projectDetailsEvent = new Subject<any>();

    get getProjectDetailsEvent() {
        return this.projectDetailsEvent;
    }

    set setProjectDetailsEvent(data: any) {
        this.projectDetailsEvent.next(data);
    }

    /**
     * Event to emit display page name to other components
     * @param pageName Name of the page to be displayed
     * @returns void
     * @example this.eventService.setDisplayPageEvent('pageName');
     * @example this.eventService.getDisplayPageEvent.subscribe((pageName: string) => { ... });
     */
    private displayPageEvent: Subject<string | null> = new Subject<string | null>();
    setDisplayPageEvent(pageName: string) {
        this.displayPageEvent.next(pageName);
    };

    get getDisplayPageEvent(): Observable<string | null> {
        return this.displayPageEvent.asObservable();
    };

    /**
     * Event to emit JD data to other components
     * @param data JD data to be emitted
     * @returns void
     * @example this.eventService.emitJDDataEvent(data);
     * @example this.eventService.jdDataEventObs.subscribe((data: JdData) => { ... });
     */
    private jdDataEvent: Subject<JdData> = new Subject();
    get jdDataEventObs(): Observable<JdData> {
        return this.jdDataEvent.asObservable();
    };

    emitJDDataEvent(data: JdData) {
        this.jdDataEvent.next(data);
    };

    /**
     * Event to emit upload candidate list event to other components    
     * @param data Data to be emitted
     * @returns void
     * @example this.eventService.setCandidateListEvent('pageName');
     * @example this.eventService.getCandidateListEvent.subscribe((pageName: string) => { ... });
     */
    private candidateListEvent: Subject<any[]> = new Subject<any[]>();
    setCandidateListEvent(data: any) {
        this.candidateListEvent.next(data);
    };

    get getCandidateListEvent(): Observable<any> {
        return this.candidateListEvent.asObservable();
    };

    /**Method to set/get applied filter data  */
    private filterAppliedEvent: Subject<any> = new Subject<any>();
    setFilterAppliedEvent(data: any) {
        this.filterAppliedEvent.next(data);
    };

    get getFiltrerAppliedEvent(): Observable<any[]> {
        return this.filterAppliedEvent.asObservable();
    };

     /**
     * Event to emit inbound applications list event to other components    
     * @param data Data to be emitted
     * @returns void
     * @example this.eventService.setInboundApplicationsListEvent('pageName');
     * @example this.eventService.getInboundApplicationsListEvent.subscribe((pageName: string) => { ... });
     */
    private inboundApplicationsListEvent: Subject<any[]> = new Subject<any[]>();
    setInboundApplicationsListEvent(data: any[]) {
        this.inboundApplicationsListEvent.next(data);
    };

    get getInboundApplicationsListEvent(): Observable<any[]> {
        return this.inboundApplicationsListEvent.asObservable();
    }

}
